import React from "react";
import { CURRENCY } from "../../constants";
import { cn } from "../../utils/utils";
import { useNavigate } from "react-router-dom";

type Props = {
  start_date: string;
  amount: any;
  title: string;
  type?: "plus" | "minus";
  transaction_type?: string;
  service?: string;
  booking_id?:number;
  booking_type?:string;
};
const bookingType: any = {
"Public matches":"public",
"Private matches":"private",
"Public events":"public_event",
"Private events":"private_event",
"Public coaching":"public_coaching",
"Private coaching":"private_coaching",
"Public coaching match":"public_coaching_match",
"Private coaching match":"private_coaching_match",
"Game with a Coach":"game_with_coach",
"Individual private coaching":"individual_private_coaching",
"Public group coaching":"public_group_coaching",
"Private group coaching":"private_group_coaching",
"Academy":"academy",
"Leagues":"league",
"Tournaments":"tournament",

}
function WalletCard({
  start_date,
  amount,
  title,
  type = "plus",
  transaction_type,
  service,
  booking_id,
  booking_type
}: Props) {
  const navigate = useNavigate();
  return (
    <div className={cn("w-full bg-[#f3f3f3] rounded-3xl p-3 flex justify-between px-5 items-center ",booking_id && 'cursor-pointer')} onClick={() => {
      if(booking_type === 'league' || booking_type === 'tournament'){
        navigate(`/competitive/${booking_type}s/view/step1/${booking_id}`)
        return
      }
      if(booking_type === 'public_event'){
        
        navigate(`/friendly/public/view/step1/${booking_id}`)
        return
      }
      if(booking_type === 'private_event'){
        navigate(`/friendly/private/view/step1/${booking_id}`)
        return
      }
      if (booking_type === "academy") {
        navigate(`/coaching/Academy/view/${booking_id}`)
        return
      }
      navigate(`/booking/${booking_id}?currentPage=1&currentSize=10&booking_type=${booking_type!}`)
    }}>
      <div>
        <p className="font-bold pb-1">
          {title}
          {transaction_type && ` (${transaction_type})`}
        </p>
       
       {booking_id && <p className="text-sm">ID {booking_id}</p>}
        <p className="text-sm">{service && "Date of Booking " }{start_date}</p>
      </div>
      <p
        className={cn(
          " font-bold",
          type === "plus" || transaction_type == "refund"
            ? "text-primaryGreen"
            : "text-primaryRed",
            transaction_type == 'cancel' && 'text-secondary'
        )}
      >
        {parseFloat(amount).toFixed(2)} {CURRENCY()}
      </p>
    </div>
  );
}

export default WalletCard;
